import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Pagination from 'ui-component/Pagination';
import Scroller from 'ui-component/Scroller';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { FaPlus, FaSearch } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton, Tooltip } from '@mui/material';
import toast from 'react-hot-toast';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePermissions from 'hooks/usePermissions';
import usePageTitle from 'hooks/usePageTitle';
import useIsMobile from 'utils/isMobileUtils';
import { FiTrash2 } from 'react-icons/fi';

// ✅ Clear
const Index = () => {
	const [setPageTitle] = usePageTitle('Warehouses');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const [params, setParams] = useSearchParams();
	const history = useNavigate();
	const [allPermissions, hasEveryPermission] = usePermissions();
	const [warehouseList, setWarehouseList] = useState([]);
	const [show, setShow] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [pagination, setpagination] = useState([]);

	const [searchField, setSearchField] = useState();
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [filters, setFilters] = useState([]);
	const [activeFilters, setActiveFilters] = useState({});
	const [isFirstLoad, setIsFirstLoad] = useState(true);


	const getWarehouseList = () => {
		setIsLoading(true);
		api.getWarehouseList().then((res) => {
			setIsLoading(false);
			setWarehouseList(res.data.data);
			setpagination(res.data);
			isFirstLoad && setIsFirstLoad(false);
		});
	};
	const handleSearch = (e) => {
		let text = e.target.value;
		setSearchField(text);

		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		let timeout = setTimeout(() => {
			setIsLoading(true);
			if (text.length > 2) {
				api.filterWarehouse(activeFilters, text).then((res) => {
					setIsLoading(false);
					setWarehouseList(res.data.data);
					setpagination(res.data);
				});
			} else if (text.length > 0 && text.length <= 2) {
				setIsLoading(false);
			} else {
				api.filterWarehouse(activeFilters, null).then((res) => {
					setIsLoading(false);
					setWarehouseList(res.data.data);
					setpagination(res.data);
				});
			}
		}, 1000);

		setSearchTimeout(timeout);
	};

	const viewData = (id) => {
		history(`/warehouses/${id}`);
	};

	useEffect(() => {
		!isFirstLoad && handleFilter();
	}, [activeFilters]);

	const handleFilter = (activeF = null, searchF = null) => {
		setIsLoading(true);
		api.filterWarehouse(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
			setIsLoading(false);
			setWarehouseList(res.data.data);
			setpagination(res.data);
		});
	};


	const handleClose = () => setShow('');

	const handleData = (data) => {
		setWarehouseList(data.data);
		setpagination(data);
	};

	useEffect(() => {
		getWarehouseList();
		getFiltersList();
	}, []);

	useEffect(() => {
		if (params.get('create') == 'shipment') {
			setParams({});
		}
	});

	const getFiltersList = () => {
		api.getWarehouseFilters().then((res) => {
			setFilters(res.data);
		});
	};


	const handleDelete = (id) => {
		toast.promise(
			api.deleteWarehouse(id).then((res) => {
				if (res.status) {
					setShow('');
					api.getWarehouseList().then((res) => {
						setIsLoading(false);
						setWarehouseList(res.data.data);
						setpagination(res.data);
						isFirstLoad && setIsFirstLoad(false);
					});
				}
				return res?.status ? res : abc;
			}),
			{
				loading: 'Deleting Warehouse...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete warehouse</b>
			}
		);
	};

	const deleteWarehouseData = (data) => {
		setShow(data);
	};

	const isMobile = useIsMobile();

	return (
		<>
			<div className="row justify-content-center m-0">
                <div className="medium-sized-container" style={{ maxWidth: '900px' }}>
					<div className="col-xl-12 col-lg-12">
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<h5 style={{ textAlign: 'center' }}>Shipments</h5>
								<div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
									<PermissionAllowed permissions={['Create Warehouse (Button)']}>
										<Link to={'/warehouses/create'} className="btn btn-primary btn-outlined-main white-var">
											<FaPlus /> New Warehouse
										</Link>
									</PermissionAllowed>
								</div>
							</div>
						</div>

						<div className="section-head-new mb-1 mar102000 hide-on-mobile" style={{ paddingLeft: '0' }}>
							<div className="actions mb10">
								<PermissionAllowed permissions={['Create Warehouse (Button)']}>
									<Link to={'/warehouses/create'} className="btn btn-primary btn-outlined-main-primary white-var">
										<FaPlus /> New Warehouse
									</Link>
								</PermissionAllowed>
							</div>
						</div>
						<div
							className="show-on-mobile"
							style={{
								display: 'flex',
								paddingLeft: 20,
								paddingRight: 20,
								paddingTop: 0,
								paddingBottom: 0,
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: 10
							}}
						>
							<form className="form-inline navbar-search" style={{ flex: 1 }}>
								<div style={{ position: 'relative', width: '100%' }}>
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										onChange={handleSearch}
										style={{ width: '100%', paddingRight: 36 }}
									/>
									<span
										className="searchIcon"
										style={{
											position: 'absolute',
											right: 10,
											top: '50%',
											transform: 'translateY(-50%)',
											color: '#888',
											pointerEvents: 'none'
										}}
									>
										<FaSearch />
									</span>
								</div>
							</form>
							<div style={{ flexShrink: 0 }}>
								<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} />
							</div>
						</div>
						<div className={`card shadow-sm  bg-white mb-4  table-card ${isMobile ? ' shorter-table' : ''}`}>
							<div className=" align-items-center justify-content-between TableSerachBar">
								<div>
									<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} />
								</div>
								<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
									<div className="input-group">
										<input
											type="text"
											className="form-control bg-white border"
											placeholder="Search"
											aria-label="Search"
											aria-describedby="basic-addon2"
											onChange={handleSearch}
											style={{ width: '100%' }}
										/>
										<span className="searchIcon">
											<FaSearch />
										</span>
									</div>
								</form>
							</div>
							{!isMobile ? (
								<div className="table-responsive-xl tableData customersList p-2">
									<Scroller>
										<table className="table pm-table">
											<thead>
												<tr className="sticky-header">
													<th scope="col">Name</th>
													<th scope="col" style={{ width: '80px' }}>
														Stocks
													</th>
													<th scope="col" style={{ width: '85px' }}>
														Reserved
													</th>
													<th scope="col" style={{ width: '100px' }}>
														Status
													</th>
													<th scope="col" style={{ width: '130px' }}>
														Stock Value
													</th>

													<PermissionAllowed permissions={['View Warehouse (Button)']}>
														<th scope="col" style={{ width: '50px' }}>
															Action
														</th>
													</PermissionAllowed>
												</tr>
											</thead>
											<tbody>
												{isLoading ? (
													[...Array(5)].map((e, i) => (
														<tr style={{ height: '35px' }} key={i}>
															{[...Array(6)].map((e, i) => (
																<td>
																	<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																</td>
															))}
														</tr>
													))
												) : (
													<>
														{warehouseList?.map((row, index) => {
															return (
																<tr key={index}>
																	<td
																		className="align-middle text-primary"
																		onClick={() => {
																			if (hasEveryPermission(['View Warehouse (Button)'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		{row?.name}
																	</td>
																	<td
																		className="align-middle text-left"
																		onClick={() => {
																			if (hasEveryPermission(['View Warehouse (Button)'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		{row?.total_stocks ?? 0}
																	</td>
																	<td
																		className="align-middle"
																		onClick={() => {
																			if (hasEveryPermission(['View Warehouse (Button)'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		{row?.stocks_reserved ?? 0}
																	</td>
																	<td
																		className="align-middle"
																		onClick={() => {
																			if (hasEveryPermission(['View Warehouse (Button)'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		<div className={`badge ${row.status == 1 ? 'badge-success' : 'badge-danger'}`}>
																			{row.status === 1 ? 'Active' : 'Inactive'}
																		</div>
																	</td>
																	<td
																		className="align-middle text-left"
																		onClick={() => {
																			if (hasEveryPermission(['View Warehouse (Button)'])) {
																				viewData(row.id);
																			}
																		}}
																		style={{
																			cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed'
																		}}
																	>
																		${row?.stock_value}
																	</td>
																	<PermissionAllowed permissions={['Delete Warehouse (Button)', 'Edit Warehouse (Button)']} hasSome>
																		<td className="align-middle action-col" style={{ marginTop: '7px' }}>
																			<Tooltip title={'Edit'} arrow placement="top">
																				<a
																					href="javascript:void(0);"
																					onClick={() => {
																						if (hasEveryPermission(['View Warehouse (Button)'])) {
																							history(`/warehouses/edit/${row?.id}`);
																						}
																					}}
																					style={{ marginRight: '3px' }}
																				>
																					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 19.875 21.722">
																						<g id="Group_40056" data-name="Group 40056" transform="translate(-2.982 -1.847)">
																							<path
																								id="Vector"
																								d="M14.452,1.27c2.195,2.076,1.559,3.774.149,5.263l-8.153,8.63a2.851,2.851,0,0,1-1.38.745l-3.2.546A1.517,1.517,0,0,1,.013,14.7l.367-3.218a3.029,3.029,0,0,1,.665-1.42L9.2,1.429c1.41-1.49,3.069-2.215,5.253-.159Z"
																								transform="translate(4.972 2.868)"
																								fill="none"
																								stroke="#06f"
																								strokeLinecap="round"
																								strokeLinejoin="round"
																								strokeWidth="2"
																							/>
																							<path
																								id="Vector-2"
																								data-name="Vector"
																								d="M5.412,5.114A6.084,6.084,0,0,1,0,0"
																								transform="translate(12.81 5.737)"
																								fill="none"
																								stroke="#06f"
																								strokeLinecap="round"
																								strokeLinejoin="round"
																								strokeWidth="2"
																							/>
																							<path
																								id="Vector-3"
																								data-name="Vector"
																								d="M0,0H17.875"
																								transform="translate(3.982 22.569)"
																								fill="none"
																								stroke="#06f"
																								strokeLinecap="round"
																								strokeLinejoin="round"
																								strokeWidth="2"
																							/>
																						</g>
																					</svg>
																				</a>
																			</Tooltip>
																			{
																				row?.is_default === false && (

																					<Tooltip title={'Delete'} arrow placement="top">
																						<a
																							href="javascript:void(0);"
																							onClick={() => {
																								if (hasEveryPermission(['Delete Warehouse (Button)'])) {
																									deleteWarehouseData(row);
																								}
																							}}
																							style={{ marginLeft: '3px' }}
																						>
																							<svg
																								id="vuesax_linear_trush-square"
																								data-name="vuesax/linear/trush-square"
																								xmlns="http://www.w3.org/2000/svg"
																								width="28"
																								height="20"
																								viewBox="0 0 31.855 31.855"
																							>
																								<g id="trush-square">
																									<path
																										id="Vector"
																										d="M0,17.255V9.291C0,2.655,2.655,0,9.291,0h7.964c6.637,0,9.291,2.655,9.291,9.291v7.964c0,6.637-2.655,9.291-9.291,9.291H9.291C2.655,26.546,0,23.891,0,17.255Z"
																										transform="translate(2.655 2.655)"
																										fill="none"
																										stroke="#ff342d"
																										strokeLinecap="round"
																										strokeLinejoin="round"
																										strokeWidth="2"
																									/>
																									<g id="Group" transform="translate(8.097 8.548)">
																										<path
																											id="Vector-2"
																											data-name="Vector"
																											d="M0,.438,1.779.265A51.533,51.533,0,0,1,6.942,0a86.992,86.992,0,0,1,8.72.438"
																											transform="translate(0 3.026)"
																											fill="none"
																											stroke="#ff342d"
																											strokeLinecap="round"
																											strokeLinejoin="round"
																											strokeWidth="2"
																										/>
																										<path
																											id="Vector-3"
																											data-name="Vector"
																											d="M0,2.588.186,1.447C.319.624.425,0,1.9,0H4.181C5.654,0,5.76.65,5.893,1.447l.186,1.128"
																											transform="translate(4.792)"
																											fill="none"
																											stroke="#ff342d"
																											strokeLinecap="round"
																											strokeLinejoin="round"
																											strokeWidth="2"
																										/>
																										<path
																											id="Vector-4"
																											data-name="Vector"
																											d="M11.932,0l-.571,8.76c-.093,1.367-.173,2.429-2.6,2.429H3.172c-2.429,0-2.509-1.062-2.6-2.429L0,0"
																											transform="translate(1.858 3.57)"
																											fill="none"
																											stroke="#ff342d"
																											strokeLinecap="round"
																											strokeLinejoin="round"
																											strokeWidth="2"
																										/>
																									</g>
																									<path id="Vector-5" data-name="Vector" d="M0,0H31.855V31.855H0Z" fill="none" opacity="0" />
																								</g>
																							</svg>
																						</a>
																					</Tooltip>
																				)
																			}

																		</td>
																	</PermissionAllowed>
																</tr>
															);
														})}
														{warehouseList?.length < 1 && (
															<tr className="no-hover">
																<td colSpan={7}>
																	<div className="not-found-container">
																		<div className="not-found-icon">
																			<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																		</div>
																		<h6 className="not-found-text">No Data Available</h6>

																		<PermissionAllowed permissions={['Create New Warehouse (Action)']}>
																			<Link to={'/warehouses/create'} className="btn btn-primary btn-outlined-main">
																				Create Warehouse
																			</Link>
																		</PermissionAllowed>
																	</div>
																</td>
															</tr>
														)}
													</>
												)}
											</tbody>
										</table>
									</Scroller>
								</div>
							) : (
								<div className="shipments-mobile-list" style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '0px 20px' }}>
									{isLoading ? (
										[...Array(7)].map((_, i) => (
											<div className="warehouse-mobile-card skeleton" key={i}>
												{[...Array(7)].map((_, j) => (
													<div className="skeleton-line" key={j}></div>
												))}
											</div>
										))
									) : warehouseList?.length > 0 ? (
										warehouseList.map((row, index) => (
											<div
												style={{
													display: 'flex',
													padding: '10px 20px',
													flexDirection: 'row',
													background: '#fff',
													borderRadius: 16,
													justifyContent: 'space-between'
												}}
												key={row.id || index}
												onClick={() => hasEveryPermission(['View Warehouse (Button)']) && viewData(row.id)}
											>
												<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', gap: 10 }}>
													<div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '100%' }}>
														<div style={{ display: 'flex', gap: 5, fontWeight: 500, width: '100%', justifyContent: 'space-between' }}>
															<div
																style={{
																	cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed',
																	color: '#316aff'
																}}
															>
																{row?.name}
															</div>
															<div style={{width: 70, display: 'flex', justifyContent: 'flex-end', alignItems: 'start'}}>
															<div className={`badge ${row.status == 1 ? 'badge-success' : 'badge-danger'}`}>
																{row.status === 1 ? 'Active' : 'Inactive'}
																</div>
																</div>
														</div>
														<div
															className="warehouse-mobile-row"
															style={{
																cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed',
																display: 'flex',
																gap: 5,
																width: '100%',
																justifyContent: 'space-between'
															}}
														>
															<div className="textGray">Accept Order</div>
															<div>{row?.can_accept_orders ? 'Yes' : 'No'}</div>
														</div>
														<div
															className="warehouse-mobile-row"
															style={{
																cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed',
																display: 'flex',
																gap: 5,
																width: '100%',
																justifyContent: 'space-between'
															}}
														>
															<div className="textGray">Default</div>
															<div>{row?.is_default ? 'Yes' : 'No'}</div>
														</div>
														<div
															className="warehouse-mobile-row"
															style={{
																cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed',
																display: 'flex',
																gap: 5,
																width: '100%',
																justifyContent: 'space-between'
															}}
														>
															<div className="textGray">General Stock</div>
															<div>{row?.can_include_stock ? 'Yes' : 'No'}</div>
														</div>
														<div
															className="warehouse-mobile-row"
															style={{
																cursor: hasEveryPermission(['View Warehouse (Button)']) ? 'pointer' : 'not-allowed',
																display: 'flex',
																gap: 5,
																width: '100%',
																justifyContent: 'space-between'
															}}
														>
															<div className="textGray">Stock Value</div>
															<div>${row?.stock_value}</div>
														</div>
														<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '100%' }}>
															<div className="warehouse-mobile-actions" style={{ display: 'flex', gap: 8 }}>
																<PermissionAllowed permissions={['View Warehouse (Button)']}>
																	<Tooltip title={'View'} arrow placement="top">
																		<div
																			className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																			style={{ minWidth: 'unset' }}
																			onClick={(e) => {
																				e.stopPropagation();
																				viewData(row.id);
																			}}
																		>
																			{/* Add your view icon here */}
																			<svg width="16" height="16" fill="none" viewBox="0 0 24 24">
																				<path
																					d="M12 5c-7 0-9 7-9 7s2 7 9 7 9-7 9-7-2-7-9-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8a3 3 0 100 6 3 3 0 000-6z"
																					fill="#316aff"
																				/>
																			</svg>
																		</div>
																	</Tooltip>
																</PermissionAllowed>
																<PermissionAllowed permissions={['Delete Warehouse (Button)']}>
																	<Tooltip title={'Delete'} arrow placement="top">
																		<div
																			className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																			style={{ minWidth: 'unset' }}
																			onClick={(e) => {
																				e.stopPropagation();
																				deleteWarehouseData(row);
																			}}
																		>
																			<FiTrash2 />
																		</div>
																	</Tooltip>
																</PermissionAllowed>
															</div>
														</div>
													</div>
												</div>
											</div>
										))
									) : (
										<div className="not-found-container">
											<div className="not-found-icon">
												<img src={NoRecordFoundIcon} style={{ height: '120px', width: '120px' }} />
											</div>
											<h6 className="not-found-text">No Data Available</h6>
											<PermissionAllowed permissions={['Create New Warehouse (Action)']}>
												<Link to={'/warehouses/create'} className="btn btn-primary btn-outlined-main">
													Create Warehouse
												</Link>
											</PermissionAllowed>
										</div>
									)}
								</div>
							)}
							<div style={{height: 20, opacity: 0}}></div>
							<Pagination pagination={pagination} data={handleData} onLoading={(e) => setIsLoading(e)} />
						</div>
					</div>
				</div>
			</div>

			{show && (
				<DeleteConfirmation
					show={show}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete ${show?.name}`}
				/>
			)}
		</>
	);
};

export default Index;
